export default __webpack_public_path__ + "static/media/sunrise.f97dc50a.svg";